<template>
    <!--弹窗-->
    <el-dialog
        width="700px"
        class="plural"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
    >
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <el-form-item label="单词:" class="query-form-item">
                <el-input
                    v-model="word_like"
                    placeholder="请输入单词"
                    style="width:160px"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button
                    icon="el-icon-search"
                    type="primary"
                    @click="onSubmit"
                    >查询</el-button
                >
            </el-form-item>
        </el-form>
        <el-table :data="list" size="mini" border>
            <el-table-column label="单词" min-width="140" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.ad_group_word }}</span>
                </template>
            </el-table-column>
            <el-table-column label="单复数形式" min-width="130" align="center">
                <template slot-scope="scope">
                    <el-input
                        v-model="scope.row.word_plural"
                        placeholder="单复数形式,多个值用','拼接"
                        size="mini"
                        style="width:260px"
                        clearable
                    ></el-input>
                </template>
            </el-table-column>
        </el-table>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                @click="handleClose"
                >取 消</el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                :loading="loading"
                >确定</el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/etyma/etyma";
export default {
    data() {
        return {
            loading: false,
            list: [],
            word_like: ""
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        onSubmit() {
            this.loading = true;
            api.get_ad_group_word_plural({ word_like: this.word_like })
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.list = res.data;
                        if (this.list.length == 0) {
                            this.$message({
                                type: "error",
                                message: "未查询到该单词的数据！"
                            });
                        }
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        submitForm() {
            if (this.list.length == 0) {
                return this.$message({
                    type: "error",
                    message: "请输入单词进行搜索单词具体数据!"
                });
            }
            let list = JSON.parse(JSON.stringify(this.list));
            let arr = [];
            list.forEach(v => {
                let str = v.word_plural;
                v.word_plural = str.replace(/\s*(,|，)\s*/g, ",").trim();
                arr.push(v);
            });
            api.update_ad_group_word_plural({ word_plural_detail: arr })
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.$message({
                            type: "success",
                            message: "修改成功"
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "网络出现问题，请查看数据是否添加完成！"
                    });
                });
        },
        // 关闭弹窗
        handleClose() {
            this.disabled = false;
            this.list = [];
            this.word_like = "";
            this.$emit("close-callback", true);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.plural {
    /deep/ .el-table__empty-block {
        border-bottom: 1px #ebeef5 solid;
    }
    /deep/ .el-dialog__body {
        padding-top: 0 !important;
    }
}
</style>
